import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import { surveyAdminContext } from "../../../context/Admin/SurveyAdminContext/SurveyAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const SurveyAdmin = () => {
  const permission = useSelector((state) => state.permission);
  const appConfigs = useSelector((state) => state.appConfigs);

  const {
    surveyItems,
    survey,
    icon,
    setIcon,
    description,
    setDescription,
    positive,
    setPositive,
    isShowModal,
    isShowDetailsModal,
    handleShowDetailsModal,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetSurveyItemList,
    handleCreateSurveyItem,
    handleDeleteSurveyItem,
  } = useContext(surveyAdminContext);

  useEffect(() => {
    handleGetSurveyItemList();
  }, []);

  return (
    <>
      <SiteTitle title="آیتم های نظرسنجی" />

      <CardLayout>
        {permission.survey_item_create && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(surveyItems) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>شناسه</th>
                <th>توضیحات</th>
                <th>آیکن</th>
                <th>نوع</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {surveyItems.map((_item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{_item.id}</td>
                  <td>{_item.description}</td>
                  <td>{_item.icon}</td>
                  <td>
                    {_item.positive ? (
                      <span className="badge badge-success">
                        <i className="bx bx-plus" /> مثبت
                      </span>
                    ) : (
                      <span className="badge badge-danger">
                        <i className="bx bx-minus" /> منفی
                      </span>
                    )}
                  </td>
                  <td className="mw-25">
                    <button
                      onClick={() => handleShowDetailsModal(_item)}
                      className="btn btn-info mr-2"
                    >
                      جزئیات
                    </button>
                    {permission.survey_item_delete && (
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteSurveyItem(_item.id),
                            `آیا از حذف آیتم نظرسنجی ${_item.id} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title="افزودن آیتم نظرسنجی"
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form onSubmit={handleCreateSurveyItem} autoComplete="off">
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="icon">آیکن</label>
              <input
                type="text"
                id="icon"
                name="icon"
                className="form-control"
                value={icon}
                onChange={(e) => setIcon(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label>نوع</label>
              <div className="d-flex  align-items-center">
                <label htmlFor="positive" className="mr-2">
                  مثبت
                </label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={positive}
                    id="positive"
                    onClick={(e) => setPositive(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <label htmlFor="positive" className="ml-2">
                  منفی
                </label>
              </div>
            </div>
            <div className="col-12 mb-2">
              <label>پیشنمایش آیکن</label>
              <div className="text-center">
                {icon && icon.length > 3 ? (
                  <img
                    src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${icon}`}
                    alt={icon}
                    className="img-fluid img-thumbnail rounded"
                  />
                ) : (
                  <p className="alert alert-info m-0">آیکنی وارد نشده است</p>
                )}
              </div>
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2"></i>
            افزودن
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات آیتم نظرسنجی"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{survey.id}</p>
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p>{survey.description}</p>
            </ItemInfo>
            <ItemInfo label="آیکن">
              <p>{survey.icon}</p>
            </ItemInfo>
            <ItemInfo label="نوع">
              <p>
                {survey.positive ? (
                  <span className="badge badge-success">
                    <i className="bx bx-plus" /> مثبت
                  </span>
                ) : (
                  <span className="badge badge-danger">
                    <i className="bx bx-minus" /> منفی
                  </span>
                )}
              </p>
            </ItemInfo>
            <ItemInfo label="پیشنمایش آیکن">
              <p className="text-center">
                <img
                  src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${survey.icon}`}
                  alt={survey.icon}
                  className="img-fluid img-thumbnail rounded"
                />
              </p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default SurveyAdmin;
